// client/src/helpers/bytes.ts
export const KiB = 1024;
export const MiB = 1024 * KiB;
export const GiB = 1024 * MiB;

const trim = (s: string) => s.replace(/\.0+$/, "");

/** Human-readable size using binary units (matches the api's 1024-based caps). */
export function formatBytes(bytes: number, digits = 1): string {
  if (!Number.isFinite(bytes) || bytes <= 0) return "0 B";
  if (bytes >= GiB) return `${trim((bytes / GiB).toFixed(digits))} GB`;
  if (bytes >= MiB) return `${trim((bytes / MiB).toFixed(digits))} MB`;
  if (bytes >= KiB) return `${trim((bytes / KiB).toFixed(digits))} KB`;
  return `${Math.round(bytes)} B`;
}

export function bytesToGb(bytes: number): number {
  return bytes / GiB;
}
